import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { StocktakingApi, StocktakingDraftApi } from "../../../../../../../../../../../services/Api/Organization/types";
import CreateStocktakingDraftModalForm from "./CreateStocktakingDraftModalForm";
import StocktakingDraftsMenuNavigation from "./StocktakingDraftsMenuNavigation";

interface Props {
	stocktakingDrafts: StocktakingDraftApi[];
	stocktaking: StocktakingApi;
	fetchStocktakingDrafts: () => Promise<StocktakingDraftApi[] | undefined>;
	handleUpdateStocktakingDraft: (index: number, stocktakingDraft: StocktakingDraftApi) => void;
}

const StocktakingDraftsMenu = ({
	stocktakingDrafts,
	stocktaking,
	fetchStocktakingDrafts,
	handleUpdateStocktakingDraft,
}: Props) => {
	const { t } = useTranslation();
	const [showCreateStocktakingDraftModal, setShowCreateStocktakingDraftModal] = useState<boolean>(false);

	return (
		<div className="stocktaking-drafts-menu-navigation">
			<StocktakingDraftsMenuNavigation
				stocktakingDrafts={stocktakingDrafts}
				handleUpdateStocktakingDraft={handleUpdateStocktakingDraft}
			/>
			{stocktaking.stocktaking_status !== "CLOSED" && (
				<div className="new-sheet-btn-container">
					<Button className="w-100" onClick={() => setShowCreateStocktakingDraftModal(true)}>
						+ {t("modules.stocktaking.action.new_draft.title")}
					</Button>
				</div>
			)}
			{showCreateStocktakingDraftModal && (
				<CreateStocktakingDraftModalForm
					isShown={showCreateStocktakingDraftModal}
					stocktakingId={stocktaking.id}
					handleSuccessAction={fetchStocktakingDrafts}
					onHide={() => setShowCreateStocktakingDraftModal(false)}
				/>
			)}
		</div>
	);
};

export default StocktakingDraftsMenu;
